/* ARCELF — interactions
   1) SP menu: hamburger → fade-in overlay (vanilla, no deps)
   2) Large images: scroll-driven zoom-out (1.14 → 1.0), Safari-safe rAF
   Safe by design: respects prefers-reduced-motion; if anything is missing
   the page renders fully (nothing is hidden by JS). */
(function () {
  'use strict';

  /* ============================================================
     1) SP hamburger menu — fade in / out
     ============================================================ */
  (function menu() {
    var header = document.querySelector('[data-arcelf-header]');
    if (!header) return;
    var toggle = header.querySelector('[data-arcelf-menu-toggle]');
    if (!toggle) return;

    var setOpen = function (open) {
      header.classList.toggle('is-menu-open', open);
      /* 追従ヘッダーが隠れた状態でメニューを開かれると、閉じた瞬間に
         ヘッダーが飛んで消えるので、開く時点で隠れフラグを落としておく */
      if (open) header.classList.remove('is-hidden');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('arcelf-menu-locked', open);
    };

    toggle.addEventListener('click', function () {
      setOpen(!header.classList.contains('is-menu-open'));
    });

    header.querySelectorAll('.arcelf-header__nav a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    /* reset when leaving the SP breakpoint */
    var mq = window.matchMedia('(min-width: 750px)');
    var onChange = function () { if (mq.matches) setOpen(false); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  })();

  /* ============================================================
     1b) 追従ヘッダー — 下スクロールで隠し、上スクロールで即出す
     ============================================================ */
  (function stickyHeader() {
    var header = document.querySelector('.arcelf-header--sticky');
    if (!header) return;

    var spacer = document.querySelector('[data-arcelf-header-spacer]');

    /* fixed で抜けた分の高さをスペーサーに実測値で反映する */
    var syncHeight = function () {
      var h = header.offsetHeight;
      if (!h) return;
      document.documentElement.style.setProperty('--arcelf-header-h', h + 'px');
      if (spacer) spacer.style.height = h + 'px';
    };
    syncHeight();
    window.addEventListener('resize', syncHeight, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(syncHeight).observe(header);

    /* 6px 未満は無視。トラックパッドの微振動でチラつかせないため。
       lastY を更新せずに抜けるので、小さい動きは積算されてやがて閾値を超える。 */
    var TOLERANCE = 6;
    /* 9/10 藤井指示: 最上部（TOP of TOP）では、この距離までスクロールしても
       ヘッダーを隠さない。1スクロールで消えてしまうのを防ぐ */
    var HIDE_AFTER = 50;
    /* 9/10 藤井指示: 左上をロゴに切り替えるのは「HERO エリアが終わってから」。
       ヒーローのあるページ（トップ）ではヒーロー下端、無いページでは HIDE_AFTER を境にする。
       ヒーローは sticky ピン留めで高さが可変なので、都度実測して閾値を取り直す */
    /* 9/28 FB④: 下層ページの静止ヒーローは「ヒーローの無いページ」と同じ扱い（最初からロゴ） */
    var hero = document.querySelector('.arcelf-hero:not(.arcelf-hero--static)');
    /* 9/10 藤井指示: ヘッダーは写真に被る前に閉じきってほしい。
       画像上端がヘッダー下端に届くのは SP で 88px（画像上端174 − ヘッダー高86）なので、
       それより手前の HIDE_AFTER=50px で隠し始める。画像基準の遅延は入れない
       （PC も同じ 50px。PC のヒーロー挙動は従来どおり sticky ＋ 時間ベースのモーフ） */
    var logoAfter = function () {
      if (!hero) return HIDE_AFTER;
      var r = hero.getBoundingClientRect();
      return Math.max(HIDE_AFTER, r.bottom + (window.pageYOffset || 0) - header.offsetHeight);
    };
    var lastY = window.pageYOffset || 0;
    var ticking = false;

    var update = function () {
      ticking = false;
      var y = window.pageYOffset || 0;
      if (y < 0) y = 0; /* iOS のバウンス */

      /* 最上部を離れたかどうか。SP の左上を「言語選択 → ロゴ」に入れ替える合図
         （9/10 藤井指示: 下へ行ってから上スクロールで出てくるヘッダーはロゴ。
           ただしトップは HERO エリアが終わるまで言語選択のまま） */
      header.classList.toggle('is-past-top', y > logoAfter());

      /* メニューを開いている間は隠さない */
      if (header.classList.contains('is-menu-open')) {
        header.classList.remove('is-hidden');
        lastY = y;
        return;
      }

      var delta = y - lastY;
      if (Math.abs(delta) < TOLERANCE) return;

      if (delta > 0 && y > HIDE_AFTER) {
        header.classList.add('is-hidden');    /* 下へ → 隠す。最上部 50px までは残す */
      } else if (delta < 0) {
        header.classList.remove('is-hidden'); /* 上へ → 即出す */
      }
      lastY = y;
    };
    update(); /* 再読み込み位置が最上部でない場合に初期状態を合わせる */

    var onScroll = function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* ============================================================
     1c) back to top — 確実に先頭へ戻す
     アンカー先の #arcelf-top は空の <span>（インライン・中身なし）で
     レイアウトボックスを持たないため、scrollIntoView が無反応だった。
     href が #arcelf-top のリンクは要素を探さず window を 0 まで戻す。
     ============================================================ */
  (function backToTop() {
    var running = false; /* 連打で prev をキャプチャし直し、scroll-behavior:auto が焼き付くのを防ぐ */

    var toTop = function (e) {
      if (e) e.preventDefault();
      if (running) return;
      var de = document.documentElement;
      var start = de.scrollTop || window.pageYOffset || 0;
      if (start <= 0) return;
      running = true;

      /* html の scroll-behavior:smooth が効いていると、こちらの代入が
         ネイティブのスムーススクロールとして扱われ、直後に behavior を戻した瞬間に
         打ち消される。アニメーション中はずっと auto にしておき、終わってから戻す。 */
      var prev = de.style.scrollBehavior;
      de.style.scrollBehavior = 'auto';

      var finish = function () {
        de.scrollTop = 0;
        de.style.scrollBehavior = prev;
        running = false;
      };

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { finish(); return; }

      /* アニメーションは setInterval で回す。requestAnimationFrame は環境によって
         1フレームも発火しないことがあり（実測）、その場合スクロールが動かなくなる。 */
      var DURATION = 520;
      var t0 = Date.now();
      var timer = window.setInterval(function () {
        var p = (Date.now() - t0) / DURATION;
        if (p >= 1) { window.clearInterval(timer); finish(); return; }
        var eased = 1 - Math.pow(1 - p, 3); /* ease-out cubic */
        de.scrollTop = Math.round(start * (1 - eased));
      }, 16);
    };

    var bind = function () {
      var links = document.querySelectorAll('a[href$="#arcelf-top"]');
      for (var i = 0; i < links.length; i++) {
        if (links[i].dataset.arcelfTopBound) continue;
        links[i].dataset.arcelfTopBound = '1';
        links[i].addEventListener('click', toTop);
      }
    };

    bind();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
    window.addEventListener('load', bind);
  })();

  /* ============================================================
     2) Scroll-driven zoom-out on large editorial images
     ============================================================ */
  (function zoom() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    var targets = Array.prototype.slice.call(
      document.querySelectorAll('.arcelf-fullimg__media img')
    );
    if (!targets.length) return;

    var MAX = 1.14, MIN = 1.0;
    var active = [];
    var ticking = false;

    var apply = function () {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = 0; i < active.length; i++) {
        var img = active[i];
        var frame = img.parentElement;
        var rect = frame.getBoundingClientRect();
        /* progress: 0 as the frame enters from the bottom, 1 as it exits the top */
        var travel = vh + rect.height;
        var passed = vh - rect.top;
        var p = passed / travel;
        if (p < 0) p = 0; else if (p > 1) p = 1;
        var scale = MAX - (MAX - MIN) * p;
        img.style.transform = 'scale(' + scale.toFixed(4) + ')';
      }
    };

    var onScroll = function () {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    };

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var idx = active.indexOf(e.target);
          if (e.isIntersecting && idx === -1) active.push(e.target);
          else if (!e.isIntersecting && idx > -1) active.splice(idx, 1);
        });
        apply();
      }, { rootMargin: '12% 0px 12% 0px' });
      targets.forEach(function (img) { io.observe(img); });
    } else {
      active = targets;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  })();
})();
